import { Component } from 'react';

export default class WithTooltip extends Component {

    constructor () {
        super();

        this.state = {
            show: false
        };
    }

    showTooltip() {
        this.setState({ show: true });
    }

    hideTooltip() {
        this.setState({ show: false });
    }

}



/** WEBPACK FOOTER **
 ** ./app/components/pages/exercisePages/AdjectiveDeclension/AdjectivesTrainer/words/WithTooltip.js
 **/